import axios from "axios";
import Vue from "vue";
import router from "@/router/index";
import { createSetCookie } from "@/utils/cookie";
import ENV from "@/mixins/const/framework/common/env";
const softBankLoginPath = "/v1/stay/sb-login";

const baseURL = process.env.VUE_APP_API_URL + "/";

const DEBUG = process.env.NODE_ENV === ENV.DEVELOPMENT;

const API = axios.create({
  baseURL,
  withCredentials: true
});

// axios.interceptors.request.use(request => {
// 	console.log('%c>>>>>>>>>>>>>>>>>>>>>>>>>>>> Axios['+request.method+'] '+request.url, 'color:#9664c3');
//   return request;
// });

/**
 * レスポンス共通処理
 */
API.interceptors.response.use(
  (response) => {
    // Vue.prototype.$error.reset();
    if (DEBUG) {
      //console.log('%c<<<<<<<<<<<< Axios['+response.config.method+'] '+response.config.url, 'color:#6c03ca; font-weight: bold');
      //console.log(response);
    }
    return response;
  },
  (error) => {
    // BFF APIのみcatchする
    if (error.response) {
      if (
        process.env.VUE_APP_API_DOMAIN + "/" ===
        error.response.config.baseURL
      ) {
        console.log("error.response >>> ", error.response);
        // APIのエラー結果を入れる前に、残っているエラー情報を削除する
        Vue.prototype.$error.reset();
        // 失敗時のレスポンス情報をstore(localstorage)に保存
        Vue.prototype.$error.code = error.response.status;
        Vue.prototype.$error.url = `[${error.response.config.method}] ${error.response.config.url}`;
        Vue.prototype.$error.data = error.response.data;
      }

      const statuscode = error.response.status;
      if (statuscode == 401) {//セッションタイムアウトになるとき、ソフトバン認証へ遷移
        document.cookie = createSetCookie("back_uri", 
          window.location.pathname + window.location.search
        );
        window.open(
          process.env.VUE_APP_API_URL +
          softBankLoginPath +
            "?back_uri=" +
            process.env.VUE_APP_BASE_URL +
            window.location.href,
          "_self"
        );
      }

      return {
        ...error.response,
        isError: true
      };
    } else {
      return false;
    }
  }
);

export default API;
